import { render, staticRenderFns } from "./NeedEditArticles.vue?vue&type=template&id=2fd84b25&scoped=true&"
import script from "./NeedEditArticles.vue?vue&type=script&lang=js&"
export * from "./NeedEditArticles.vue?vue&type=script&lang=js&"
import style0 from "./NeedEditArticles.vue?vue&type=style&index=0&id=2fd84b25&prod&lang=css&"
import style1 from "./NeedEditArticles.vue?vue&type=style&index=1&id=2fd84b25&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd84b25",
  null
  
)

export default component.exports